// LocalStorage
import {gConst} from './AppVariables.js'

const APP_LS_KEY = gConst.APP_NAME + ".AppLocalStorage"
const ACC_LS_KEY = gConst.APP_NAME + ".AccLocalStorage"
const GLOSSARY_LS_KEY = gConst.APP_NAME + ".GlossaryLocalStorage"
console.log("APP_LS_KEY: ", APP_LS_KEY)
console.log("ACC_LS_KEY: ", ACC_LS_KEY)
const ACCOUNT_ID_DEFAULT = 0

const gAppLocalStorage =
{
	"LastAccountID": ACCOUNT_ID_DEFAULT
}

const gAccLocalStorage =
{
	"AccountID": ACCOUNT_ID_DEFAULT,
	"FirstLogin": false,
	"LoginName": '',
	"Credential": '',
	"SysType": 1,
	"CredentialExpiredTime": "",
	"LastCalledSN": 0,
	"EmailVerified": -1, // window.gEmailVerifyEnum.None
	"Authorized": '',
	"Preferences": '',
	"IsOAuthLogin": false,
	"OAuthLoginObject": null,
	"SubscriptionReminder": '',		// 授權提醒     Tim.20.04.15
	"PreludeLastChapterID": 1,
	"CurrentClassIndex": -1,
	"TipCount": 0,					// 顯示 Tip次數
	"LastLoginTime": '',			// 最後登入時間，用來判斷 Tip需不需要重新設定
	"AccDashboard": '',
	"IsMicTipAgainFirst": true, 	// Tip
	"IsNextTipFirst": true, 		// Tip
	"IsAudioTipFirst": true, 		// Tip

	"MultiTabsMessage": ""			// CredentialMultiIn 機制       Tim將檔案從React BI搬過來 Tim22.11.02
}

const gGlossaryLocalStorage =
{
	"ID": "App",
	"Version": "0",
	"Glossary": null,
	"ContentVerType": -1
}

export {
	APP_LS_KEY,
	ACC_LS_KEY,
	ACCOUNT_ID_DEFAULT,
	GLOSSARY_LS_KEY,
	gAppLocalStorage,
	gAccLocalStorage,
	gGlossaryLocalStorage
}
